import { Maybe } from '@monetize/types/common';
import { HtmlIFrameContentRenderer } from '../../../components/Monetize/HtmlIFrameContentRenderer';

interface ReviewQuoteHtmlProps {
  currentPdfFile: Maybe<string>;
  isReFetching?: boolean;
}

export const ReviewQuoteHtml = ({
  currentPdfFile,
  isReFetching,
}: ReviewQuoteHtmlProps) => {
  if (!currentPdfFile) {
    return null;
  }

  return (
    <HtmlIFrameContentRenderer
      id="quote-content"
      html={currentPdfFile}
      isReFetching={isReFetching}
    ></HtmlIFrameContentRenderer>
  );
};
